module.exports = __webpack_public_path__ + "img/seminarscore.39fc452d.png";